import Alert from './Alert';
import uploadHandler from './uploadHandler';
import router from './router';
import toggleCheckBoxes from './toggleCheckBoxes';
import confirm from './confirmation/confirm';
import urlParser from './urlParser';
import colorParser from './colorParser';
import { shortcutIcon } from '../../../helpers/dotenv';
import {
	searchCompany,
	searchUser,
	searchCustomer,
	searchIntegrations,
} from './searchers';
import smsCounter from './smsCounter';
import { permissionKeys } from './Permission/Keys';
import { permissionModulesKeys } from './Permission/ModulesKeys';
import { permissionUrlKeys } from './Permission/UrlKeys';

export function myCustomStructuredClone(someThing) {
	if (
		someThing === null ||
		someThing === undefined ||
		typeof someThing === "string" ||
		typeof someThing === "number" ||
		typeof someThing === "undefined" ||
		typeof someThing === "function"
	) {
		return someThing;
	}
	if (typeof someThing === "object") {
		if (Array.isArray(someThing)) {
			const anotherArray = [];
			for (const item of someThing) {
				anotherArray.push(myCustomStructuredClone(item));
			}
			return anotherArray;
		} else {
			const godBlessAmerica = {};
			for (const key of someThing) {
				godBlessAmerica[key] = myCustomStructuredClone(someThing[key]);
			}
			return godBlessAmerica;
		}
	}
	return someThing;
}

export function cacher(func) {
	let cache = new Map();

	return function(x) {
		if (!cache.has(x)) {
			cache.set(x, func(x));
		}
		return cache.get(x);
	};
}

export const checkAccessForList = (accessDefination, list) => {
	const newList = list.filter((ele) => {
		const newChilds = ele.childs.filter((e) => {
			return e.link
				? isAccessForAll(
						accessDefination,
						permissionUrlKeys[
							e.link
								.split('/')
								.pop()
								.toLowerCase()
						]
				  )
				: true;
		});
		if (newChilds.length !== 0) {
			ele.childs = newChilds;
			return true;
		}
		return false;
	});

	return newList;
};

export const makeActive = (list, link) => {
	list.forEach((ele) => {
		if (list.length === 1 && ele.childs.length === 1 && !list[0].keepClosed) {
			ele.isShow = 'block';
			ele.arrow = 'keyboard_double_arrow_up';
		}
		ele.childs.map((e) => {
			if (e.link === link) {
				e.active = true;
				ele.isShow = 'block';
				ele.arrow = 'keyboard_double_arrow_up';
			}
		});
	});
	return list;
};

export const capitalize = (string) => {
	let splitArr = string.split(' ').filter(word => word);
	splitArr.forEach((word, i) => {
		splitArr[i] = word[0].toUpperCase() + word.slice(1);
	});
	return splitArr.join(' ');
};

export const validateUrl = (value) => {
	return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
}

export const isAccessForAll = (obj, array) => {
	let access = true;
	if (obj && array) {
		if (typeof array === 'object') {
			for (let i = 0; i < array.length; i++) {
				const ele = array[i];
				if (obj[ele]) {
					let acc = isAccess(obj[ele].options, ['list', 'allow-view']);
					if (acc === true) {
						access = true;
						break;
					} else {
						access = false;
					}
				}
			}
		} else {
			const ele = array;
			if (obj[ele]) {
				let acc = isAccess(obj[ele].options, ['list', 'allow-view']);
				if (acc === true) {
					access = true;
				} else {
					access = false;
				}
			}
		}
	}

	return access;
};

export const isAccess = (obj, key) => {
	let access = true;
	if (typeof obj === 'object' && Object.keys(obj).length !== 0) {
		if (typeof key === 'string' && typeof obj[key] === 'boolean') {
			return obj[key];
		} else if (typeof key === 'object' && key.length !== 0) {
			for (let i = 0; i < key.length; i++) {
				if (obj[key[i]] === true) {
					access = true;
					break;
				} else {
					access = false;
				}
			}
		}
	}

	return access;
};

export const possiblePermissions = {
	none: 0,
	read: 3,
	write: 5,
	full: 7,
};

export const isGreaterThanRead = (access) => {
	return true;
};
export const isGreaterThanWrite = (access) => {
	return true;
};

export const debounce = (func, timer) => {
	let timeout;
	return function() {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, arguments), timer);
	};
}

export const renderFullName = (data) => {
	if (data.firstName || data.lastName) {
		return (data.firstName || '') + ' ' + (data.lastName || '');
	}
	return data.email || data.phone || 'N/A';
};

export const setTitle = (title, force) => {
	if (!document.title.includes(title) || force) {
		document.title = title;
	}
};

export const setBadge = (count, title) => {
	const favicon = document.getElementById('favicon');

	if (count) {
		if (document.title.includes(title)) {
			setTitle(`(${count}) ${title}`);
		}

		return (favicon.href = '/favicon-unread.png');
	}

	favicon.href = `/images/${shortcutIcon}`;
};

export const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);

	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};

export const generateRandomColorCode = () => {
	return `#${Math.random()
		.toString(16)
		.slice(2, 8)}`;
};

// Create an array with "stop" numbers, starting from "start"
export const range = (start, stop) => {
	return Array.from(Array(stop), (_, i) => start + i);
};

// Return the list of values that are the intersection of two arrays
export const intersection = (array1, array2) => {
	return array1.filter((n) => array2.includes(n));
};

// Computes the union of the passed-in arrays: the list of unique items
export const union = (array1, array2) => {
	return array1.concat(array2.filter((n) => !array1.includes(n)));
};

// Similar to without, but returns the values from array that are not present in the other arrays.
export const difference = (array1, array2) => {
	return array1.filter((n) => !array2.includes(n));
};

export const removeSpecific = function(arr) {
	var what,
		a = arguments,
		L = a.length,
		ax;
	while (L > 1 && arr.length) {
		what = a[--L];
		while ((ax = arr.indexOf(what)) !== -1) {
			arr.splice(ax, 1);
		}
	}
	return arr;
};

export const arrayToObject = (arr = []) => {
	let result = {};
	arr.forEach((el) => {
		if (el.key && el.value) {
			result[el.key] = el.value;
		}
	});
	return result;
};
export const objectToArray = (obj) => {
	let result = [];
	for (const prop in obj) {
		if (prop && obj[prop]) {
			result.push({ key: prop, value: obj[prop] });
		}
	}
	return result;
};

export {
	Alert,
	permissionKeys,
	permissionModulesKeys,
	permissionUrlKeys,
	uploadHandler,
	router,
	confirm,
	toggleCheckBoxes,
	urlParser,
	colorParser,
	searchCompany,
	searchUser,
	searchIntegrations,
	searchCustomer,
	smsCounter,
};



// WEBPACK FOOTER //
// src/modules/common/utils/index.js